import "./App.css";
import Router from "./routes";
import BackgroundImage from "./assets/png/layout_bg.png";
// import { getBusinessLocations } from "./redux/slices/businessLocation/businessLocationSlice";

function App() {
  return (
    <html>
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <div
          className="bg-white font-poppins"
          // style={{
          //   backgroundImage: `url(${BackgroundImage})`,
          //   backgroundRepeat: "repeat",
          //   backgroundSize: "contain"
          // }}
        >
          <Router />
        </div>
      </body>
    </html>
  );
}

export default App;
